import * as types from '../constants';

const initialState = {
  loading: true,
  xmlFeeds: {},
  pushFeeds: {},
  feedInfo: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_XML_FEEDS_START:
      return {
        ...state,
        loading: true,
        xmlFeeds: {},
      };

    case types.FETCH_XML_FEEDS_SUCCESS:
      return {
        ...state,
        loading: false,
        xmlFeeds: action.payload,
      };

    case types.FETCH_XML_FEEDS_FAILURE:
      return {
        ...state,
        loading: true,
        err: action.err,
      };

    case types.FETCH_PUSH_FEEDS_START:
      return {
        ...state,
        loading: true,
        pushFeeds: {},
      };

    case types.FETCH_PUSH_FEEDS_SUCCESS:
      return {
        ...state,
        loading: false,
        pushFeeds: action.payload,
      };

    case types.FETCH_PUSH_FEEDS_FAILURE:
      return {
        ...state,
        loading: true,
        err: action.err,
      };

    case types.FETCH_FEED_INFO_START:
      return {
        ...state,
        feedInfo: [],
      };

    case types.FETCH_FEED_INFO_SUCCESS:
      return {
        ...state,
        feedInfo: action.payload,
      };

    case types.FETCH_FEED_INFO_FAILURE:
      return {
        ...state,
        err: action.err,
      };

    default:
      return state;
  }
};

export default reducer;
